import { render, staticRenderFns } from "./WindowPaneGlazingType.vue?vue&type=template&id=6e523d56&scoped=true"
import script from "./WindowPaneGlazingType.vue?vue&type=script&lang=ts"
export * from "./WindowPaneGlazingType.vue?vue&type=script&lang=ts"
import style0 from "./WindowPaneGlazingType.vue?vue&type=style&index=0&id=6e523d56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e523d56",
  null
  
)

export default component.exports